const formatImageInput = v => {
  return v && !v.rawFile ? { src: v } : v;
};
export default formatImageInput;
